/* Conseils avant et après un soin — version française (référence).
 * Conseils généraux de prudence, sans promesse de résultat et sans se
 * substituer à la consultation. */

const conseilsFr = {
    eyebrow: "Préparer et suivre son soin",
    h1: "Conseils avant et après un soin",
    lead: "Un soin bien préparé se passe mieux et récupère plus vite. Voici les précautions que nous rappelons en consultation, réunies ici pour que vous puissiez les relire chez vous. Elles ne remplacent pas les consignes personnalisées données par le médecin, qui priment toujours.",
    beforeTitle: "Avant n'importe quelle séance",
    beforeLead:
        "Ces règles valent pour tous les soins réalisés au cabinet, du peeling à l'épilation laser :",
    beforeItems: [
        "signalez toute grossesse, tout allaitement et tout traitement en cours, y compris les compléments alimentaires et les crèmes prescrites",
        "signalez un herpès récidivant, un antécédent de cicatrice en relief ou une maladie auto-immune : certains gestes se préparent ou se reportent",
        "venez démaquillée, sans parfum ni autobronzant sur la zone traitée",
        "évitez l'exposition solaire et les cabines UV dans les deux semaines qui précèdent",
        "prévenez si vous avez reçu un vaccin ou un soin esthétique ailleurs dans les quinze derniers jours",
        "prévoyez un créneau sans contrainte juste après : pas de sport intense, pas de sauna, pas d'événement important le soir même",
    ],
    laserTitle: "Avant une séance d'épilation laser ou d'électrolyse",
    laserItems: [
        "rasez la zone la veille ou le matin : le poil doit être présent sous la peau, mais pas à la surface",
        "ne vous épilez ni à la cire, ni à la pince, ni au fil pendant les quatre semaines précédentes, le laser a besoin de la racine",
        "pas d'autobronzant pendant deux semaines, pas de bronzage récent sur la zone",
        "arrêtez les gommages et les actifs exfoliants deux à trois jours avant",
        "prévenez si vous prenez un médicament photosensibilisant, certains antibiotiques en font partie",
    ],
    peelTitle: "Avant un peeling, un microneedling ou une mésothérapie",
    peelItems: [
        "suspendez rétinoïdes, acides et gommages cinq à sept jours avant, sauf indication contraire du médecin",
        "signalez tout traitement par isotrétinoïne, actuel ou récent",
        "prévoyez la séance à distance d'un événement : rougeur et desquamation sont possibles pendant quelques jours",
        "hydratez bien votre peau les jours précédents, une peau souple réagit mieux",
        "en cas d'herpès labial récidivant, un traitement préventif peut être prescrit avant un soin du visage",
    ],
    injTitle: "Avant des injections",
    injItems: [
        "évitez l'aspirine, l'ibuprofène et les compléments qui fluidifient le sang dans les jours précédents, sauf s'ils vous sont prescrits — n'arrêtez jamais un traitement de vous-même",
        "évitez l'alcool la veille, il majore les bleus",
        "mangez normalement avant de venir",
        "ne prévoyez pas d'injection la semaine d'un mariage, d'un voyage ou d'une photo importante",
        "signalez tout soin dentaire prévu ou récent, qui peut justifier de décaler la séance",
    ],
    afterTitle: "Après la séance",
    afterParagraphs: [
        "Des suites existent pour presque tous les soins : rougeur, chaleur, léger gonflement, petits bleus après des injections, desquamation après un peeling. Elles sont habituelles, transitoires, et vous sont annoncées avant la séance. Ce qui compte ensuite, c'est de laisser la peau tranquille.",
        "Pendant quarante-huit heures, on évite la chaleur et les frottements. On ne gratte pas, on ne gomme pas, on n'arrache pas les petites peaux : c'est ainsi que l'on évite les marques.",
    ],
    afterItems: [
        "pas de sport intense, de hammam, de sauna, de piscine ni de bain chaud pendant 48 heures",
        "nettoyage doux, soin hydratant simple, pas de produit nouveau dans les jours qui suivent",
        "pas de maquillage sur la zone pendant 24 heures après un microneedling, une mésothérapie ou des injections",
        "protection solaire élevée tous les jours, même par temps couvert",
        "pas de massage ni de pression sur la zone injectée, sauf consigne contraire du médecin",
        "buvez normalement et dormez la tête légèrement surélevée la première nuit après des injections du visage",
    ],
    soleilTitle: "Le soleil, le vrai sujet",
    soleilParagraphs: [
        "La photoprotection n'est pas un détail de confort : c'est elle qui protège le bénéfice d'un soin. Sur une peau fragilisée par un peeling, un laser ou un microneedling, une exposition même brève peut laisser une tache durable, en particulier sur les peaux pigmentées et en cas de mélasma.",
        "Un indice élevé s'applique le matin et se renouvelle dans la journée en cas d'exposition, toute l'année, y compris derrière une vitre. Chapeau, lunettes et ombre complètent utilement la crème pendant les semaines qui suivent un soin.",
    ],
    alerteTitle: "Quand reprendre contact",
    alerteLead:
        "La plupart des suites se résolvent seules. Contactez le cabinet, ou un médecin si vous ne pouvez pas joindre le cabinet, si vous observez :",
    alerteItems: [
        "une douleur qui augmente au lieu de diminuer après 48 heures",
        "une rougeur qui s'étend, une zone chaude, une fièvre",
        "une cloque, une croûte épaisse ou une plaie qui ne se referme pas",
        "une zone qui blanchit, devient violacée ou perd sa sensibilité après une injection",
        "tout signe qui vous inquiète et dont nous n'avions pas parlé",
    ],
    alerteFin:
        "En cas d'urgence médicale, n'attendez pas de réponse : appelez le 15 ou le 112, ou rendez-vous au service d'urgences le plus proche. Le cabinet n'assure pas la prise en charge des urgences.",
    faqTitle: "Questions fréquentes sur les suites d'un soin",
    faq: [
        [
            "Puis-je me maquiller après une séance ?",
            "Après un peeling superficiel, en général oui dès le lendemain. Après un microneedling, une mésothérapie ou des injections, mieux vaut attendre vingt-quatre heures : la peau comporte de micro-ouvertures et le maquillage augmente le risque d'irritation. La consigne exacte vous est donnée en fin de séance.",
        ],
        [
            "Combien de temps durent les bleus après une injection ?",
            "Lorsqu'un bleu apparaît, il s'estompe habituellement en cinq à dix jours, parfois un peu plus sur les lèvres et les cernes. Il se couvre très bien avec un correcteur une fois la peau refermée.",
        ],
        [
            "Puis-je faire du sport le jour même ?",
            "Il vaut mieux l'éviter pendant quarante-huit heures. L'effort augmente la chaleur, la transpiration et l'afflux sanguin, trois facteurs qui majorent la rougeur, le gonflement et le risque de bleu.",
        ],
        [
            "Que faire si ma peau pèle après un peeling ?",
            "C'est l'effet recherché. On laisse faire : nettoyage doux, hydratation, protection solaire, et surtout on n'arrache pas les peaux, même celles qui pendent. Les arracher est le meilleur moyen de laisser une tache.",
        ],
        [
            "Ces conseils remplacent-ils une consultation ?",
            "Non. Ils donnent le cadre général des soins pratiqués au cabinet. Vos consignes dépendent de votre peau, de vos traitements et du soin réalisé : seules celles qui vous sont données en consultation font foi.",
        ],
    ],
};

export default conseilsFr;
